import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { z } from 'zod';
import { ForumListPage } from '@/features/forum';

const ForumSearchSchema = z.object({
  kind: z
    .enum(['discussion', 'question', 'announcement', 'survey-link', 'poll', 'ama', 'event-rsvp'])
    .optional(),
  sort: z.enum(['recent', 'newest', 'top']).optional(),
  group: z.string().uuid().optional(),
  category: z.string().uuid().optional(),
  includeHidden: z
    .preprocess((value) => {
      if (value === true || value === 'true') return true;
      if (value === false || value === 'false') return false;
      return undefined;
    }, z.boolean().optional()),
  q: z.string().optional(),
  tag: z.string().max(40).optional(),
});

export const Route = createFileRoute('/forum')({
  component: ForumRoute,
  validateSearch: (search) => ForumSearchSchema.parse(search),
});

function ForumRoute(): ReactNode {
  const search = Route.useSearch();
  return (
    <ForumListPage
      {...(search.kind !== undefined ? { kind: search.kind } : {})}
      {...(search.sort !== undefined ? { sort: search.sort } : {})}
      {...(search.group !== undefined ? { group: search.group } : {})}
      {...(search.category !== undefined ? { category: search.category } : {})}
      {...(search.includeHidden !== undefined ? { includeHidden: search.includeHidden } : {})}
      {...(search.q !== undefined ? { q: search.q } : {})}
      {...(search.tag !== undefined ? { tag: search.tag } : {})}
    />
  );
}
